











































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { getChannelOption, setContentSeq } from '@/api/common'
import { IBanner } from '@/api/content/content-banner/res'
import {
  getBannerType,
  getBannerList,
  getBannerEditInfo,
  setBannerTop,
  deleteBanner,
  addEditBanner
} from '@/api/content/content-banner/banner'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson, resetObjValue2NoneString, deepCopy, compareDate } from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
import { AppModule } from '@/store/modules/app'
import Sortable from 'sortablejs'
type channelType = 360 | 361
type isChoose = 1 | -1
const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'BannerList'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    nid: '',
    appId: '',
    appName: '',
    editor: '',
    status: '',
    updateDateStart: '',
    updateDateEnd: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private addParams = {
    id: 0,
    nids: '',
    name: '',
    relateId: 0,
    bannerType: '',
    startDate: '',
    endDate: '',
    isShow: 1,
    isExternal: -1,
    seq: 0,
    imgUrl: '',
    imgLink: ''
  }
  private renderCascaderKey = 0
  // template data
  tableLoading = false
  private tableData: IBanner[] = []
  private selectedData: IBanner[] = []
  private selectList: any[] = [] // 级联选择
  private asideList: any[] = [] // 侧栏选择
  private value: number[] = [] // 级联选中项
  private openeds: string[] = [] // 侧栏展开项
  private dateArray1: string[] = ['', '']
  private dateArray2: string[] = ['', '']
  private totalCount: number = 0
  routeQuery: IQuery = { id: 0 }
  activeIndex: string = '0'
  private addFormVisible: boolean = false
  private bannerTypeList: any[] = []
  private formPlatform = ''
  // 上架渠道
  private channelList: any[] = []
  private channelOption: any[] = []
  private rules: any = {
    name: [{ required: true, message: '请填写banner名称', trigger: 'blur' }],
    bannerType: [{ required: true, message: '选择banner类型', trigger: 'change' }],
    startDate: [
      {
        required: true,
        message: '请选择开始时间',
        trigger: 'blur'
      }
    ],
    seq: [{ required: true, type: 'number', message: '请填写排序号', trigger: 'blur' }],
    isExternal: [{ required: true, message: '选择链接类型', trigger: 'change' }],
    imgLink: [{ required: false, type: 'url', message: '请填写有效的链接地址', trigger: 'blur' }],
    relateId: [{ required: true, type: 'number', message: '请填写关联id', trigger: 'blur' }]
  }
  private tableHeight: number = 500
  // lifecycle
  async created() {
    await this.getChannelOption()
    await this.getAsideOption()
    await this.getTableData()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  mounted() {
    this.rowDrop()
  }
  // methods
  async getChannelOption() {
    // 顶部菜单
    let res = await getChannelOption({
      type: 3,
      pos: 'top',
      pid: 359
    })
    this.selectList = res.data
    this.value = [360, 362, 618]
  }
  // 左侧菜单: 必须传一个 id 或者初始菜单
  async getAsideOption(pid = 618) {
    let res: any = await getChannelOption({
      type: 3,
      pos: 'left',
      pid: pid
    })
    this.asideList = res.data
    this.params.nid = res.data[0].children[0]['value']
    this.activeIndex = res.data[0].children[0]['value'].toString()
    this.openeds = this.asideList.map(item => item.value.toString())
  }
  async getTableData() {
    this.tableLoading = true
    let res = await getBannerList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.icon = cover
      this.tableData.push(el)
    })
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].icon, header).then(res => {
        this.tableData[i]['icon'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async setBannerTop(ids: string, isTop: -1|1) {
    let res: any = await setBannerTop({
      nid: Number(this.params.nid),
      ids: ids,
      isTop
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
    } else {
      this['$message'].error('操作失败')
    }
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 270 - filterDom.clientHeight
  }
  rowDrop() {
    const table = document.querySelector('.el-table__body-wrapper tbody')
    console.log(table)
    const _this = this
    // table 有值时才能对其进行操作
    if (table) {
      Sortable.create(table, {
        handle: '.bars',
        onEnd({ oldIndex, newIndex }: any) {
          if (oldIndex !== newIndex) {
            console.log(oldIndex, newIndex)
          }
        }
      })
    }
  }
  deleteBanner(ids: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteBanner({
          nid: Number(this.params.nid),
          ids: ids
        })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
  async getUpChannel(pid: channelType) {
    let res: any = await getChannelOption({
      type: 3,
      pos: 'all',
      pid: pid
    })
    this.channelOption = res.data
    console.log(this.channelOption)
    ++this.renderCascaderKey
  }
  getChannelOptionValues(data: any[]) {
    let arr: any[] = []
    function recursion(data: any[]) {
      data.forEach(item => {
        if (item.children) {
          recursion(item.children)
        } else {
          arr.push(item.value)
        }
      })
    }
    recursion(data)
    return arr
  }
  handleInput(val: string, attr: string) {
    (this.params as any)[attr] = val.replace(/[^0-9]/g, '')
  }
  async getBannerType() {
    let res = await getBannerType()
    this.bannerTypeList = res.data.dataList
  }
  async getBannerEditInfo(id: number, nid: number) {
    let res: any = await getBannerEditInfo({ id, nid })
    if (res.status.code === 0) {
      let obj = res.data
      // 保证数据响应
      let values = this.getChannelOptionValues(this.channelOption)
      let channelList = obj.nids.splice(0)
      let channelMap = new Map(channelList.map((channel: any[]) => [channel[3], channel]))
      // console.log(channelMap)
      let arr: any[] = []
      // 对数据进行排序
      values.forEach(n => {
        let node = channelMap.get(n)
        if (node) {
          arr.push(node)
        }
      })
      this.channelList = arr
      this.addParams.nids = deepCopy(this.channelList).reduce((pre:any, cur:any) => {
        return cur.pop() + ',' + pre
      }, '').slice(0, -1)
      this.addParams.name = obj.name
      this.addParams.relateId = obj.relateId
      this.addParams.bannerType = obj.type
      this.addParams.startDate = obj.startDate
      this.addParams.endDate = obj.endDate
      this.addParams.isShow = obj.isShow
      this.addParams.isExternal = obj.isExternal
      this.addParams.seq = obj.seq
      this.addParams.imgUrl = obj.picUrl
      this.addParams.imgLink = obj.url
    } else {
      this['$message'].error('获取banner信息错误')
    }
  }
  async addEditBanner() {
    let res: any = await addEditBanner({
      id: this.addParams.id,
      relateId: this.addParams.relateId,
      nids: this.addParams.nids,
      name: this.addParams.name,
      bannerType: this.addParams.bannerType,
      startDate: this.addParams.startDate,
      endDate: this.addParams.endDate,
      isShow: this.addParams.isShow as isChoose,
      isExternal: this.addParams.isExternal as isChoose,
      seq: this.addParams.seq,
      imgUrl: this.addParams.imgUrl.split(domain).pop() as string,
      imgLink: this.addParams.imgLink,
      isIos: this.formPlatform === 'ios' ? 1 : 3
    })
    console.log(res)
    if (res.status.code === 0) {
      this['$message'].success('发布成功!')
      this.cancelAddForm()
    } else {
      this['$message'].error('发布失败!')
    }
  }
  // 切换一级分类
  async handleSelectOne(v: number[]) {
    let pid = v[2]
    await this.getAsideOption(pid)
    await this.getTableData()
  }
  // 切换二级分类
  handleSelectSecond(index: string) {
    this.params.nid = index
    this.getTableData()
  }
  handleDateChange1(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleDateChange2(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['nid', 'page', 'pageCount'])
    this.params.page = 1
    this.dateArray1 = ['', '']
    this.dateArray2 = ['', '']
    this.getTableData()
  }
  goToAdd() {
    // 表单初始化
    let pid: 360 | 361 = this.platform === 'ios' ? 360 : 361
    // this.$router.push({ name: 'BannerAddEdit', query: { platform: this.platform } })
    this.getBannerType()
    this.formPlatform = this.platform
    this.getUpChannel(pid)
    this.addFormVisible = true
  }
  handleSelectionChange(list: IBanner[]) {
    this.selectedData = list
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    this['$message'].warning('暂不支持...')
    // let t: number[] = []
    // this.selectedData.forEach(item => {
    //   t.push(item.id)
    // })
    // this.routeQuery = {
    //   id: t.join(',')
    // }
  }
  handleRemoveAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    this.deleteBanner(ids)
  }
  async setTopApp(item: IBanner, isTop: -1|1) {
    let ids = item.id.toString()
    await this.setBannerTop(ids, isTop)
    await this.getTableData()
  }
  async updateApp(item: IBanner) {
    let pid: 360 | 361 = this.platform === 'ios' ? 360 : 361
    // let query: any = { platform: this.platform, id: item.id, nid: this.params.nid }
    // this.$router.push({ name: 'BannerAddEdit', query })
    await this.getBannerType()
    this.formPlatform = this.platform
    await this.getUpChannel(pid)
    const { id } = item
    let nid = Number(this.params.nid)
    this.addParams.id = id
    this.getBannerEditInfo(id, nid)
    this.addFormVisible = true
  }
  removeApp(item: IBanner) {
    let ids = item.id.toString()
    this.deleteBanner(ids)
  }
  handleFormPlatformChange(v: string) {
    let pid: channelType = v === 'ios' ? 360 : 361
    this.getUpChannel(pid)
  }
  handleChangeChannel(list: number[][]) {
    let t: any[] = JSON.parse(JSON.stringify(list))
    let nids = t.reduce((pre, cur) => {
      return cur.pop() + ',' + pre
    }, '')
    this.addParams.nids = nids.slice(0, -1)
  }
  cancelAddForm() {
    (this.$refs['addParams'] as Form).resetFields()
    this.addFormVisible = false
  }
  confirmAddForm() {
    // TODO: 提交请求
    if (this.disabled) {
      return false
    }
    (this.$refs['addParams'] as Form).validate(valid => {
      if (valid && this.addParams.imgUrl) {
        // let isDateValid = compareDate(this.addParams.startDate, this.addParams.endDate)
        // if (!isDateValid) {
        //   this['$message'].warning('上架结束时间必须大于上架开始时间')
        //   return
        // }
        this.addFormVisible = false
        this.addEditBanner()
      } else {
        this['$message'].error('请填写缺失参数!')
        return false
      }
    })
  }
  handleResetForm() {
    this.cancelAddForm()
    this.channelList = []
    this.addParams.id = 0
    this.addParams.nids = ''
    this.addParams.name = ''
    this.addParams.relateId = 0
    this.addParams.bannerType = ''
    this.addParams.startDate = ''
    this.addParams.endDate = ''
    this.addParams.isShow = -1
    this.addParams.isExternal = -1
    this.addParams.seq = 0
    this.addParams.imgUrl = ''
    this.addParams.imgLink = ''
  }
  async handleExcel() {
    // let excelParams = deepCopy(this.params)
    // let res: any = await getBannerList(Object.assign(excelParams, {
    //   nid: this.params.nid,
    //   page: 1,
    //   pageCount: 3000
    // }))
    // if (res.status.code === 0) {
    //   this['$message'].success('导出成功')
    // } else {
    //   this['$message'].error('导出失败')
    //   return
    // }
    const filterVal: string[] = [
      'seq',
      'id',
      'name',
      'isShow',
      'startDate',
      'endDate',
      'viewCount',
      'editor'
    ]
    const theader: string[] = [
      '排序',
      'ID',
      '应用名',
      '是否展示(1:是, -1:否)',
      '开始展示时间',
      '结束展示时间',
      '查看量',
      '编辑人'
    ]
    if (this.selectedData.length <= 0) {
      return this.$message.warning('请选择数据')
    }
    const list = this.selectedData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    this['$message'].success('导出成功!')
    ;(this.$refs['multiTable'] as any).clearSelection()
  }
  async handleEdit(i: number, item: IBanner) {
    const { id, seq } = item
    if (typeof seq === 'string' && seq === '') {
      this['$message'].warning('请输入排序!')
      return false
    } else if (seq <= 0) {
      this['$message'].warning('排序不得小于等于0!')
      return false
    }
    let nid = this.params.nid
    let res: any = await setContentSeq({
      nid: Number(nid),
      relateId: id,
      seq: seq
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
      await this.getTableData()
    } else {
      this['$message'].error('操作失败')
    }
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get platform() {
    return (this.value && this.value[0]) === 360 ? 'ios' : 'android'
  }
  get disabled() {
    return AppModule.uploadDisabled
  }
}
